import { useReducer, useEffect, useCallback } from 'react'
import { Model } from '../models/model'
/* import { fetchConToken } from '../helpers/fetch' */

const initialState = {
    notificaciones: [],
    noLeidas: 0,
    loading: true,
    error: null
}

const reducer = (state, action) => {
    switch (action.type) {

        case 'CARGA_EXITOSA':
            return {
                ...state,
                notificaciones: action.payload.notificaciones,
                noLeidas: action.payload.noLeidas,
                loading: false,
                error: null
            }

        case 'CARGA_ERROR':
            return { ...state, loading: false, error: action.payload }

        case 'CARGANDO':
            return { ...state, loading: true, error: null }

        case 'NUEVA_NOTIFICACION':
            return {
                ...state,
                notificaciones: [action.payload, ...state.notificaciones],
                noLeidas: state.noLeidas + 1
            }

        case 'MARCAR_LEIDA':
            return {
                ...state,
                notificaciones: state.notificaciones.map(n =>
                    n.id === action.payload ? { ...n, leida: true } : n
                ),
                noLeidas: Math.max(0, state.noLeidas - 1)
            }

        case 'MARCAR_TODAS_LEIDAS':
            return {
                ...state,
                notificaciones: state.notificaciones.map(n => ({ ...n, leida: true })),
                noLeidas: 0
            }

        case 'ARCHIVAR':
            return {
                ...state,
                notificaciones: state.notificaciones.filter(n => n.id !== action.payload)
            }

        default:
            return state
    }
}

export const useNotificaciones = () => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const cargar = useCallback(async (filtros = {}) => {
        dispatch({ type: 'CARGANDO' })

        const params = new URLSearchParams()
        if (filtros.modulo) params.append('modulo', filtros.modulo)
        if (filtros.leida !== undefined) params.append('leida', filtros.leida)
        if (filtros.limit) params.append('limit', filtros.limit)

        const data = await Model.getOne({
            url: `/notificaciones?${params.toString()}`
        })

        if (data) {
            dispatch({ type: 'CARGA_EXITOSA', payload: data })
        } else {
            dispatch({ type: 'CARGA_ERROR', payload: 'Error al cargar notificaciones' })
        }
    }, [])

    const marcarLeida = useCallback(async (id) => {
        dispatch({ type: 'MARCAR_LEIDA', payload: id })
        await Model.update({
            url: `/notificaciones/${id}/leida`,
            dataForm: {},
            showMessage: false
        })
    }, [])

    const marcarTodasLeidas = useCallback(async () => {
        dispatch({ type: 'MARCAR_TODAS_LEIDAS' })
        await Model.update({
            url: '/notificaciones/leidas/todas',
            dataForm: {},
            showMessage: false
        })
    }, [])

    const archivar = useCallback(async (id) => {
        dispatch({ type: 'ARCHIVAR', payload: id })
        await Model.update({
            url: `/notificaciones/${id}/archivar`,
            dataForm: {},
            showMessage: false
        })
    }, [])

    // SSE — tiempo real
    useEffect(() => {
        const token = localStorage.getItem('token')
        const url = `${process.env.REACT_APP_API_URL}/notificaciones/stream?token=${token}`
        const sse = new EventSource(url)

        sse.onmessage = (e) => {
            dispatch({ type: 'NUEVA_NOTIFICACION', payload: JSON.parse(e.data) })
        }

        sse.onerror = () => sse.close()

        return () => sse.close()
    }, [])

    useEffect(() => {
        cargar()
    }, [cargar])

    return {
        ...state,
        cargar,
        marcarLeida,
        marcarTodasLeidas,
        archivar
    }
}